import {
	trigger,
	transition,
	style,
	query,
	animateChild,
	group,
	animate,
} from '@angular/animations';

export const routeTransitionAnimations = trigger('routeAnimations', [
	// Transition from login to app content
	transition('login => app-content', [
		style({ position: 'relative' }),
		query(':enter, :leave', [
			style({
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100vh',
			}),
		]),
		query(':enter', [
			style({
				transform: 'scale(0.9)',
				opacity: 0,
			}),
		]),
		query(':leave', animateChild()),
		group([
			query(':leave', [
				animate(
					'600ms ease-in-out',
					style({
						transform: 'scale(1.1)',
						opacity: 0,
					}),
				),
			]),
			query(':enter', [
				animate(
					'600ms ease-in-out',
					style({
						transform: 'scale(1)',
						opacity: 1,
					}),
				),
			]),
		]),
		query(':enter', animateChild()),
	]),

	// Transition from app content back to login
	transition('app-content => login', [
		style({ position: 'relative' }),
		query(':enter, :leave', [
			style({
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100vh',
			}),
		]),
		query(':enter', [
			style({
				transform: 'scale(0.9)',
				opacity: 0,
			}),
		]),
		query(':leave', animateChild()),
		group([
			query(':leave', [
				animate(
					'600ms ease-in-out',
					style({
						transform: 'scale(1.1)',
						opacity: 0,
					}),
				),
			]),
			query(':enter', [
				animate(
					'600ms ease-in-out',
					style({
						transform: 'scale(1)',
						opacity: 1,
					}),
				),
			]),
		]),
		query(':enter', animateChild()),
	]),

	// Forward navigation (incrementing: 1->2, 2->3, etc.)
	transition(':increment', [
		style({ position: 'relative' }),
		query(
			':enter, :leave',
			[
				style({
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
				}),
			],
			{ optional: true },
		),
		query(
			':enter',
			[
				style({
					opacity: 0,
				}),
			],
			{ optional: true },
		),
		query(':leave', animateChild(), { optional: true }),
		// First fade out the leaving view
		query(
			':leave',
			[
				animate(
					'150ms ease-out',
					style({
						opacity: 0,
					}),
				),
			],
			{ optional: true },
		),
		// Then fade in the entering view
		query(
			':enter',
			[
				animate(
					'150ms ease-out',
					style({
						opacity: 1,
					}),
				),
			],
			{ optional: true },
		),
		query(':enter', animateChild(), { optional: true }),
	]),

	// Backward navigation (decrementing: 5->4, 4->3, etc.)
	transition(':decrement', [
		style({ position: 'relative' }),
		query(
			':enter, :leave',
			[
				style({
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
				}),
			],
			{ optional: true },
		),
		query(
			':enter',
			[
				style({
					opacity: 0,
				}),
			],
			{ optional: true },
		),
		query(':leave', animateChild(), { optional: true }),
		// First fade out the leaving view
		query(
			':leave',
			[
				animate(
					'150ms ease-out',
					style({
						opacity: 0,
					}),
				),
			],
			{ optional: true },
		),
		// Then fade in the entering view
		query(
			':enter',
			[
				animate(
					'150ms ease-out',
					style({
						opacity: 1,
					}),
				),
			],
			{ optional: true },
		),
		query(':enter', animateChild(), { optional: true }),
	]),
]);
